import { css } from "emotion";
import {
  H3,
  H4,
  P,
  Label,
  Note
} from "../../../components/text/TextComponents";
import Image from "../../../components/Image";
import { Component } from "preact";

const tapePurple = require("../../../assets/tape/tape_purple.svg");
const tapeTeal = require("../../../assets/tape/tape_teal.svg");
const tape = [tapePurple, tapeTeal];

const wrapper = css({
  maxWidth: 860,
  margin: "0 auto",
  marginTop: 72,
  "@media(max-width: 860px)": {
    display: "none"
  }
});

const activeMemberWrapper = css({
  position: "relative",
  minHeight: 220,
  paddingLeft: 244,
  marginBottom: 24
});

const activeMemberMug = css({
  position: "absolute",
  top: 0,
  left: 0,
  width: 220,
  height: 220,
  borderRadius: 4
});

const activeMemberTape = css({
  position: "absolute",
  zIndex: 9,
  top: -20,
  left: "calc(110px - 12px)"
});

const memberSelectWrapper = css({
  "&:after": {
    content: '""',
    clear: "both",
    display: "block"
  }
});

const memberWrapper = css({
  float: "left",
  width: 140,
  textAlign: "center",
  marginRight: 40,
  "&:last-child": {
    marginRight: 0
  }
});

const memberMug = {
  width: 140,
  height: 140,
  borderRadius: 4,
  "&:hover": {
    cursor: "pointer",
    boxShadow: "2px 2px 10px 4px rgba(9, 30, 66, 0.13)"
  }
};

const mobileWrapper = css({
  display: "none",
  position: "relative",
  width: "calc(100% - 28px)",
  margin: "0 auto",
  overflow: "auto",
  overflowX: "scroll",
  "@media(max-width: 860px)": {
    display: "block"
  }
});

const nowrap = css({
  whiteSpace: "nowrap",
  "&:after": {
    content: '""',
    clear: "both",
    display: "block"
  }
});

const mobileMemberWrapper = css({
  backgroundColor: "#ffffff",
  width: 240,
  position: "relative",
  padding: "201px 14px 32px 14px",
  textAlign: "center",
  display: "inline-block",
  marginRight: 16,
  whiteSpace: "initial",
  verticalAlign: "top",
  "&:last-child": {
    marginRight: 0
  }
});

const mobileMemberMug = css({
  width: 140,
  height: 140,
  position: "absolute",
  top: 49,
  right: 50,
  borderRadius: 4
});

const mobileMemberTape = css({
  position: "absolute",
  top: 20,
  right: "calc(50% - 12px)"
});

class Members extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: 0
    };
  }

  propsUpdated = () => {
    this.setState({
      selected: 0
    });
  };

  changeSelected = index => {
    this.setState({
      selected: index
    });
  };

  render() {
    const { selected } = this.state;
    const { people } = this.props;
    let randomTapeStrip = Math.floor(Math.random() * tape.length);
    return (
      <div>
        <div className={wrapper}>
          <div className={activeMemberWrapper}>
            <Image
              imageURL={people[selected].mug}
              styleSheet={activeMemberMug}
              alt={`${people[selected].name}`}
            />
            <Image
              imageURL={tape[randomTapeStrip]}
              styleSheet={activeMemberTape}
              alt="sticky tape holding up photo"
            />
            <H4 marginBottom={6}>{people[selected].name}</H4>
            <P semiBold color="#5a626c" marginBottom={12}>
              {people[selected].title}
            </P>
            {people[selected].blurb.split("\n").map(paragraph => {
              return <P marginBottom={12}>{paragraph}</P>;
            })}
          </div>
          {people.length > 1 ? (
            <div className={memberSelectWrapper}>
              {people.map((person, index) => {
                return (
                  <a
                    className={memberWrapper}
                    onClick={() => this.changeSelected(index)}
                    href="javascript:"
                  >
                    <Image
                      imageURL={person.mug}
                      styleSheet={css({
                        ...memberMug,
                        boxShadow:
                          index === selected
                            ? "2px 2px 10px 8px rgba(9, 30, 66, 0.13)"
                            : "inherit"
                      })}
                      alt={`${person.name}`}
                    />
                    <Label semiBold>{person.name}</Label>
                  </a>
                );
              })}
            </div>
          ) : null}
        </div>
        <div className={mobileWrapper}>
          <div className={nowrap}>
            {people.map(person => {
              randomTapeStrip = Math.floor(Math.random() * tape.length);
              return (
                <div className={mobileMemberWrapper}>
                  <Image
                    imageURL={person.mug}
                    alt={`${person.name}`}
                    styleSheet={mobileMemberMug}
                  />
                  <Image
                    imageURL={tape[randomTapeStrip]}
                    styleSheet={mobileMemberTape}
                    alt="sticky tape holding up photo"
                  />
                  <H3 marginBottomMobile={6} marginBottom={6}>
                    {person.name}
                  </H3>
                  <Note
                    color="#5a626c"
                    marginBottomMobile={16}
                    marginBottom={16}
                  >
                    {person.title}
                  </Note>
                  <div style={{ textAlign: "left" }}>
                    <P>{person.blurb}</P>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

export default Members;
